'use client'

import { cn } from '@/util/cn'
import { useState } from 'react'

type Props = {
    alt?: string
    className?: string
    isVisible?: boolean
    src: string
    width: number
}

const checkerBackground =
    "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4AQMAAACSSKldAAAABlBMVEUhIiIWFhYoSqvJAAAAGElEQVQY02MAAv7///8PWxqIPwDZw5UGABtgwz2xhFKxAAAAAElFTkSuQmCC') 0 0"

const GifDragDropOverlay = ({ alt = '', className, isVisible = true, src, width }: Props) => {
    const [isGrabbing, setGrabbing] = useState(false)

    return (
        <div
            className={cn(
                'absolute inset-0 transition-opacity duration-200',
                isVisible ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0',
                isGrabbing ? 'cursor-grabbing' : 'cursor-grab',
                className
            )}
            onMouseDown={() => setGrabbing(true)}
            onMouseLeave={() => setGrabbing(false)}
            onMouseUp={() => setGrabbing(false)}
        >
            <div className="absolute right-0 bottom-0 left-0 h-10">
                <div
                    className="absolute top-0 right-0 bottom-0 left-0 h-10 opacity-50"
                    style={{
                        background: checkerBackground,
                        backgroundSize: '27px',
                    }}
                />
                <div className="relative flex h-full items-center justify-center text-center font-bold text-giphyWhite">
                    Drag &amp; Drop {width > 300 ? 'this GIF' : ''} anywhere!
                </div>
            </div>
            <div className="absolute inset-0 block opacity-0">
                <img alt={alt} className="h-full w-full" draggable height="100%" src={src} width="100%" />
            </div>
        </div>
    )
}

export default GifDragDropOverlay
